"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualTableStyle = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ContextualTableStyle = (function (_super) {
    __extends(ContextualTableStyle, _super);
    function ContextualTableStyle(props) {
        var _this = _super.call(this, props) || this;
        _this.borderTypeOptions = [
            {
                label: commonTypes_1.TableBorderType.All,
                value: commonTypes_1.TableBorderType.All,
                icon: react_1.default.createElement(icons_1.BordersAll, null),
            },
            {
                label: commonTypes_1.TableBorderType.Horizontal,
                value: commonTypes_1.TableBorderType.Horizontal,
                icon: react_1.default.createElement(icons_1.BordersHorizontal, null),
            },
        ];
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter" || event.key === "Tab") {
                _this.props.reselectText();
                event.preventDefault();
                event.stopPropagation();
                event.target.blur();
            }
        };
        _this.handleBorderTypeChange = function (tableBorderType) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableBorder = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableBorder"));
            tableBorder.borderType = tableBorderType;
            blockStyleStore.setElementStyle("tableBorder", tableBorder);
        };
        _this.convertToInputOpacity = function (cssOpacity) {
            if (!cssOpacity) {
                return 100;
            }
            return Math.round(Number(cssOpacity) * 100);
        };
        _this.convertToOpacity = function (inputValue) {
            return Number(inputValue) / 100;
        };
        _this.handleBorderOpacityChange = function (opacityInputValue) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableBorder = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableBorder"));
            var opacity = _this.convertToOpacity(opacityInputValue);
            tableBorder.color.opacity = opacity;
            tableBorder.color.abs = (0, ColorUtils_1.replaceOpacity)(tableBorder.color.abs, opacity);
            blockStyleStore.setElementStyle("tableBorder", tableBorder);
        };
        _this.handleBackgroundToggle = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableBackground = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableBackground"));
            tableBackground.on = !tableBackground.on;
            blockStyleStore.setElementStyle("tableBackground", tableBackground);
        };
        _this.handleHeaderToggle = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableHeader = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableHeader"));
            tableHeader.on = !tableHeader.on;
            blockStyleStore.setElementStyle("tableHeader", tableHeader);
        };
        _this.handleHeaderColor = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableHeader = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableHeader"));
            tableHeader.color = {
                themeIndex: color.themeIndex,
                abs: color.value,
            };
            blockStyleStore.setElementStyle("tableHeader", tableHeader);
        };
        _this.handleBackgroundColor = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableBackground = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableBackground"));
            tableBackground.color = {
                themeIndex: color.themeIndex,
                abs: color.value,
            };
            blockStyleStore.setElementStyle("tableBackground", tableBackground);
        };
        _this.handleBorderColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var tableBorder = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("tableBorder"));
            tableBorder.color.themeIndex = color.themeIndex;
            tableBorder.color.abs = (0, ColorUtils_1.replaceOpacity)(color.value, tableBorder.color.opacity);
            blockStyleStore.setElementStyle("tableBorder", tableBorder);
        };
        return _this;
    }
    ContextualTableStyle.prototype.render = function () {
        var _a = this.props, colors = _a.colors, blockStyleStore = _a.blockStore.blockStyleStore;
        var tableHeader = blockStyleStore.getElementStyle("tableHeader");
        var tableBackground = blockStyleStore.getElementStyle("tableBackground");
        var tableBorder = blockStyleStore.getElementStyle("tableBorder");
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "style-shortcut__header" }, "Table style"),
            react_1.default.createElement("div", { onKeyDown: this.handleKeyPress },
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_2.ToggleTheme.Dark, label: "Top row color", value: tableHeader.on, onChange: this.handleHeaderToggle }),
                    tableHeader.on && (react_1.default.createElement(ColorPalette_1.default, { presetColors: colors, onColorChange: this.handleHeaderColor, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(tableHeader.color), colors), type: "content" })),
                    react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_2.ToggleTheme.Dark, label: "Background color", value: tableBackground.on, onChange: this.handleBackgroundToggle }),
                    tableBackground.on && (react_1.default.createElement(ColorPalette_1.default, { presetColors: colors, onColorChange: this.handleBackgroundColor, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(tableBackground.color), colors), type: "content" }))),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Border type", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.borderTypeOptions, selectedValue: tableBorder.borderType, onClickHandler: this.handleBorderTypeChange })),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Border color"),
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(ColorPalette_1.default, { type: "content", presetColors: DefaultColors_1.defaultBorderColors, onColorChange: this.handleBorderColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(tableBorder.color), DefaultColors_1.defaultBorderColors) }))),
                react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: this.handleBorderOpacityChange, theme: kaleidoscope_1.SliderTheme.Dark, label: "Border transparency", unit: "%", initialInputValue: this.convertToInputOpacity(tableBorder.color.opacity) }))));
    };
    ContextualTableStyle = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ContextualTableStyle);
    return ContextualTableStyle;
}(react_1.default.Component));
exports.ContextualTableStyle = ContextualTableStyle;
exports.default = (0, WithColorFilterSubscription_1.default)(ContextualTableStyle);
